export const onUseAnchor = (anchorId: string) => {
    const link = document.createElement('a')
    link.href = `#${anchorId}`
    document.body.appendChild(link)
    link.click()
    link.remove()
    if (window.history.pushState) {
        window.history.pushState('', '/', window.location.pathname)
    } else {
        window.location.hash = ''
    }
}
